import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {useHistory, useLocation} from 'react-router-dom';
import {connect} from 'react-redux';
import SideDrawerItem from './SideDrawerItem';


import {ReactComponent as User} from '../../assets/User.svg';
import {ReactComponent as Catalog} from '../../assets/Catalog.svg';
import {ReactComponent as Forms} from '../../assets/Forms.svg';
import {ReactComponent as Workflows} from '../../assets/Workflows.svg';
import {ReactComponent as Device} from '../../assets/Device.svg';
import {ReactComponent as Services} from '../../assets/Services.svg';
import {ReactComponent as Theme} from '../../assets/Theme.svg';
import {ReactComponent as VideoCalls} from '../../assets/VideoCalls.svg';
import {ReactComponent as Support} from '../../assets/Support.svg';
import {ReactComponent as Policy} from '../../assets/Policy.svg';
import {ReactComponent as Contract} from '../../assets/Contract.svg';
import {ReactComponent as Alerts} from '../../assets/Alerts.svg';
import {ReactComponent as Tickets} from '../../assets/Tickets.svg';

import SideDrawerSelectorComponent from './SideDrawerSelectorComponent';
import SlideInLeftToRight from '../animations/SlideInLeftToRight';
import {roles} from '../../utils/auth';

const SideDrawerWrapper = styled.div`
    position: relative;
    width: 100px;
    height: 100vh;

    /* company */
    background: #E2E8F0;//var(--gray-primary);
`;

const DrawerItemsWrapper = styled.div`
    //overflow-y: scroll;
    display: flex;
    flex-direction: column;
    padding: 10px 8px;
    top: 0;
`;

const bamSideDrawerData = [
    {
        id: 1,
        icon: User,
        path: '/company/customers',
        name: 'Customers',
    },
    // {
    //     id: 2,
    //     icon: Forms,
    //     path: '/company/forms',
    //     name: 'Form',
    // },
    // {
    //     id: 3,
    //     icon: Workflows,
    //     path: '/company/workflows',
    //     name: 'Workflows',
    // },
    // {
    //     id: 4,
    //     icon: Catalog,
    //     path: '/company/catalog',
    //     name: 'Catalog',
    // },
    // {
    //     id: 5,
    //     icon: VideoCalls,
    //     path: '/company/video-calls',
    //     name: 'Video Calls',
    // },
    // {
    //     id: 6,
    //     icon: Theme,
    //     path: '/company/theme',
    //     name: 'Theme',
    // },
    // {
    //     id: 7,
    //     icon: Services,
    //     path: '/company/services',
    //     name: 'Services',
    // },
    {
        id: 8,
        icon: Alerts,
        path: '/Alerts',
        name: 'Alerts',
    },
];

const gkSideDrawerData = [
    {
        id: 1,
        icon: User,
        path: '/fulfillment/customers',
        name: 'Customers',
    },
    {
        id: 1,
        icon: Contract,
        path: '/fulfillment/contracts',
        name: 'Contracts',
    },
    {
        id: 1,
        icon: Policy,
        path: '/fulfillment/policies',
        name: 'Policies',
    },
    {
        id: 1,
        icon: Alerts,
        path: '/Alerts',
        name: 'Alerts',
    },
    // {
    //     id: 1,
    //     icon: Support,
    //     path: "/fulfillment/support",
    //     name: "Support",
    // },
    // {
    //     id: 1,
    //     icon: Tickets,
    //     path: "/fulfillment/tickets",
    //     name: "Tickets",
    // },
];

const customerSideDrawerdata = [
    {
        id: 1,
        icon: Contract,
        path: '/customers/contracts',
        name: 'Contracts',
    },
    {
        id: 1,
        icon: Device,
        path: '/customers/devices',
        name: 'Devices',
    },
    // {
    //     id: 1,
    //     icon: Alerts,
    //     path: "/Alerts",
    //     name: "Alerts",
    // },
    // {
    //     id: 1,
    //     icon: Support,
    //     path: "/customers/support",
    //     name: "Support",
    // },
];

const smsSideDrawerData = [
    {
        id: 1,
        icon: User,
        path: '/fulfillment/customers',
        name: 'Customers',
    },
    {
        id: 1,
        icon: Contract,
        path: '/fulfillment/contracts',
        name: 'Contracts',
    },
    {
        id: 1,
        icon: Policy,
        path: '/fulfillment/policies',
        name: 'Policies',
    },
    {
        id: 1,
        icon: Alerts,
        path: '/Alerts',
        name: 'Alerts',
    },
    // {
    //     id: 1,
    //     icon: Support,
    //     path: "/fulfillment/support",
    //     name: "Support",
    // },
    // {
    //     id: 1,
    //     icon: Tickets,
    //     path: "/fulfillment/tickets",
    //     name: "Tickets",
    // },
];


const getSideDrawerData = userRole => {
    switch (userRole) {
    case roles.ADMIN:
        return [...gkSideDrawerData, ...customerSideDrawerdata, ...bamSideDrawerData];

    case roles.GK:
        return gkSideDrawerData;

    case roles.CUSTOMER_REP:
        return customerSideDrawerdata;

    case roles.BAM:
    case roles.COMPANY:
        return bamSideDrawerData;

    case roles.SMS:
        return smsSideDrawerData;
    default:
        return [];
    }
};


/**
 *
 **/
function SideDrawerContainer({auth}) {
    // Select drawer option based on the user that loaded
    const drawerData = getSideDrawerData(auth.role);

    const sideDrawData = (drawerData);
    const history = useHistory();
    const location = useLocation();

    const setupDrawerProps = drawerData => {
        const drawerProps = [];
        drawerData.forEach(drawerData => {
            const drawProp = {
                DrawerIcon: drawerData.icon,
                onIconClick: () => {
                    history.push(drawerData.path);
                },
                iconLabel: drawerData.name,
                path: drawerData.path,
                isSelected: location.pathname.substring(0, drawerData.path.length) === drawerData.path
            };

            drawerProps.push(drawProp);
        });

        return drawerProps;
    };

    const getIndexOfSelected = selectedPath => {
        for (let index = 0; index < sideDrawData.length; index++) {
            const {path} = sideDrawData[index];
            if (selectedPath.includes(path)) return index;
        }
    };


    const drawerProps = setupDrawerProps(sideDrawData);
    const selectedDrawer = getIndexOfSelected(location.pathname);

    console.log('location pathname', location);

    return (
        <SlideInLeftToRight>
            <SideDrawerWrapper key="side-drawer">

                <SideDrawerSelectorComponent selectorPosition={selectedDrawer}/>

                <DrawerItemsWrapper>
                    {
                        /**
                         * Side Drawer Item List
                         **/
                        drawerProps.map((props, index) => <SideDrawerItem key={index} {...props}/>)
                    }
                </DrawerItemsWrapper>

            </SideDrawerWrapper>
        </SlideInLeftToRight>
    );
}


SideDrawerContainer.propTypes = {auth: PropTypes.object.isRequired};

const mapStateToProps = state => ({auth: state.auth});


export default connect(
    mapStateToProps
)(SideDrawerContainer);
